import { Button, Stack, Typography } from '@mui/material';

import AuthModal, { authModalStyles } from './AuthModal';
import PinInput from '@/components/PinInput';

type PinInputModalProps = {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  newStudioId?: number;
  onPinSubmit?: () => void;
  setPinCallback?: (pin: string, isCancelled: boolean) => void;
};

const PinInputModal = ({
  isOpen,
  onClose,
  headerText,
  newStudioId,
  onPinSubmit = () => {},
  setPinCallback
}: PinInputModalProps) => {
  const authModalClasses = authModalStyles();

  return (
    <AuthModal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setPinCallback('', true);
      }}
    >
      <Typography className={authModalClasses.header} align="center">
        {headerText}
      </Typography>
      <PinInput
        onSuccess={() => {
          onPinSubmit();
          onClose();
        }}
        newStudioId={newStudioId}
        setPinCallback={setPinCallback}
      />
      <Stack className={authModalClasses.buttonContainer}>
        <Button
          fullWidth
          variant="contained"
          className={authModalClasses.cancelButton}
          onClick={() => {
            onClose();
            setPinCallback('', true);
          }}
        >
          Cancel
        </Button>
      </Stack>
    </AuthModal>
  );
};

export default PinInputModal;
